import React from "react";
import { useDiscussionsUnread } from "../hooks/useDiscussionsSummary";

/**
 * Count pill for the sidebar's Discussions item: unread comments across every
 * discussion the user is in. Renders nothing at zero. Same placement and
 * shape as the Bug Reports chip; gold rather than red because unread talk is
 * attention, not an alarm.
 */
const DiscussionsUnreadChip: React.FC = () => {
    const unread = useDiscussionsUnread();
    if (unread <= 0) return null;

    return (
        <span
            className="badge rounded-pill ms-2"
            style={{ backgroundColor: "#d9e021", color: "#000" }}
            title={`${unread} unread comment${unread === 1 ? "" : "s"} in your discussions`}
        >
            {unread > 99 ? "99+" : unread}
        </span>
    );
};

export default DiscussionsUnreadChip;
